"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M19.57 3.95c-1.92-1.29-4.08-1.17-5.8-.26L12 9h1.66c.67 0 1.15.65.96 1.29l-1.82 6.07c-.09.29-.52.2-.49-.1L13 10h-1.67c-.66 0-1.14-.64-.96-1.27l1.18-4.11c-1.85-1.73-4.84-2.3-7.28-.58C2.82 5.07 2 6.7 2 8.49c-.01 3.81 3.53 6.71 8.66 11.3.76.68 1.92.69 2.69.01 4.98-4.42 8.87-7.58 8.64-11.62-.09-1.73-.99-3.26-2.42-4.23"
}), 'HeartBrokenRounded');